const reportsRoutes = [
    {
        path: "/reports",
        name: "reports",
        component: () => import("@/views/reports/Reports.vue")
    }
]
export default reportsRoutes